import styled from 'styled-components';

export default styled.div`
  font-weight: 500;

  small {
    display: block;
    font-size: 0.75rem;
    font-weight: 400;
  }
`;
